import { STORE_PAYMENTS } from '../actions/types';

const initialState = {
    payments: [],
};

const paymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case STORE_PAYMENTS:
            return { ...state, payments: action.payload };
        default:
            return state;
    }
};

export default paymentsReducer;
